import React, { useState, useEffect } from 'react';
import axios from 'axios';

// MUI Components
import FormControl from '@mui/material/FormControl';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const Dropdown = ({ 
    label, 
    name, 
    options = [], 
    fetchEndpoint, 
    value = null, 
    placeholder, 
    onChange, 
    error,
    className = '',
    multiple = false,
    required = false,
    readOnly = false,
    bg = 'transparent',
    allowClear = true
}) => {
    
    const [localOptions, setLocalOptions] = useState([]);
    const [currentValue, setCurrentValue] = useState(multiple ? [] : '');

    const onSelect = (event, newValue) => {
        setCurrentValue(newValue);
        let updatedValue;
        if( multiple ){
            updatedValue = newValue.map(option => option.value);
        }
        else{
            if( newValue === null ){
                updatedValue = null;
            }
            else{
                updatedValue = newValue.value;
            }
        }
        let updatedData = {
            target: {
                name: name,
                value: updatedValue
            }
        }
        onChange(updatedData);
    }

    useEffect(() => {
        if( options.length === 0 && fetchEndpoint ){
            axios.get(fetchEndpoint).then(response => {
                setLocalOptions(response.data);
            });
        }
        else if( options.length > 0 ){
            setLocalOptions(options);
        }
    }, [options, fetchEndpoint]);

    useEffect(() => {
        if( value !== null && value !== undefined && value !== currentValue ){
            if( multiple ){
                setCurrentValue( options.filter(option => value.includes(option.value)) );
            }
            else{
                setCurrentValue( options.find(option => option.value === value) );
            }
        }
    }, [value, options]);

    return (
        <div className={`form-group dropdown ${error ? 'error' : ''} ${className}`}>
            {label &&
                <label htmlFor={name}>
                    {label}
                    {required && <span className='required'>*</span>}
                </label>
            }
            <FormControl className={`form-group ${error ? 'error' : ''}`} sx={{ backgroundColor: bg }}>
                <Autocomplete
                    name={name}
                    value={currentValue}
                    onChange={onSelect}
                    options={localOptions}
                    getOptionLabel={(option) => option.label || ''}
                    renderInput={params => <TextField {...params} placeholder={placeholder || 'Select...'} />}
                    multiple={multiple}
                    readOnly={readOnly}
                    disableClearable={!allowClear}
                />
            </FormControl>
        </div>
    );

};

export default Dropdown;